import * as angular from 'angular';
import template from './confirm-modal.html';

/**
 * @deprecated Prefer the `ConfirmDialogService`
 */
const confirmModalDirective = function (Modal, $sce: angular.ISCEService) {
  return {
    restrict: 'A',

    link: function ($scope: any, $elem: angular.IAugmentedJQuery) {
      $elem.on('click.confirm', (event) => {
        event.preventDefault();

        if ($elem.attr('disabled') == null) {
          let content = $scope.confirmModal;
          if ($scope.confirmModal.startsWith('#')) {
            content = $sce.trustAsHtml(angular.element($scope.confirmModal).html());
          }

          const modal = Modal.open(
            {
              title: $scope.confirmModalTitle,
              text: content,
              confirmText: $scope.confirmModalButtonConfirm,
              cancelText: $scope.confirmModalButtonCancel,
              confirmButtonClass: $scope.confirmModalButtonClass,
              onlyConfirm: !!$scope.confirmOnly,
              confirmButtonType: $scope.confirmModalButtonType,
              confirmButtonColor: $scope.confirmModalButtonConfirmColor,
            },
            {
              template: template,
            }
          );

          modal.result.then(() => $scope.confirmModalOnConfirm()).catch(function () {});
        } else {
          event.stopPropagation();
        }
      });

      // cleanup handlers
      $scope.$on('$destroy', () => $elem.off('click.confirm'));
    },

    scope: {
      confirmModal: '@',
      confirmModalTitle: '@',
      confirmModalOnConfirm: '&',
      confirmModalButtonType: '@',
      confirmModalButtonConfirm: '@?',
      confirmModalButtonCancel: '@?',
      confirmModalButtonClass: '@?',
      confirmOnly: '@?',
      confirmModalButtonConfirmColor: '@?',
    },
  };
};

confirmModalDirective.$inject = ['ModalService', '$sce'];

angular.module('mode.components').directive('confirmModal', confirmModalDirective);
